import React, { useState } from 'react';
import './Contact.css';
import { useLanguage } from './LanguageContext';

function Contact() {
  const { t } = useLanguage();
  const [status, setStatus] = useState(''); // Poate fi: '', 'success', 'error'

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    
    try {
      // INLOCUIESTE LINKUL DE MAI JOS CU CEL DAT DE FORMSPREE
      const response = await fetch("https://formspree.io/f/mredbjwy", {
        method: "POST",
        body: new FormData(form),
        headers: {
          'Accept': 'application/json'
        }
      });
      
      if (response.ok) {
        setStatus('success');
        form.reset(); // Curățăm formularul după trimitere
      } else {
        setStatus('error');
      }
    } catch (error) {
      setStatus('error');
    }
  };

  return (
    <div 
      className="contact-page"
      style={{ backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.8)), url("/images/fatada.jpeg")' }}
    >
      <div className="contact-container">
        
        <div className="contact-header">
          <h1>{t('contact_title')}</h1>
          <p>{t('contact_subtitle')}</p>
        </div>

        <div className="form-wrapper">
          {/* Afișăm mesaje de succes sau eroare */}
          {status === 'success' && <div className="status-msg success">{t('contact_success')}</div>}
          {status === 'error' && <div className="status-msg error">{t('contact_error')}</div>}
          
          <form onSubmit={handleSubmit} className="contact-form">
            <div className="form-group">
              <label htmlFor="name">{t('contact_name')}</label>
              <input type="text" id="name" name="name" required />
            </div>
            
            <div className="form-group">
              <label htmlFor="email">{t('contact_email')}</label>
              <input type="email" id="email" name="email" required />
            </div>
            
            <div className="form-group">
              <label htmlFor="message">{t('contact_message')}</label>
              <textarea id="message" name="message" rows="6" required></textarea>
            </div>
            
            <button type="submit" className="submit-btn">{t('contact_send')}</button>
          </form>
        </div>

      </div>
    </div>
  );
}

export default Contact;